import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.GlobalSearchResultTabs'

export default defineMessages({
  filterGroupLabel: {
    id: `${scope}.filterGroupLabel`,
    defaultMessage: 'Filter by result type',
  },
  allTab: {
    id: `${scope}.allTab`,
    defaultMessage: 'All ({count})',
  },
  orderRequestTab: {
    id: `${scope}.orderRequestTab`,
    defaultMessage:
      '{count, plural, one {Order request} other {Order requests}} ({count})',
  },
  expenseRequestTab: {
    id: `${scope}.expenseRequestTab`,
    defaultMessage:
      '{count, plural, one {Expense request} other {Expense requests}} ({count})',
  },
  travelRequestTab: {
    id: `${scope}.travelRequestTab`,
    defaultMessage:
      '{count, plural, one {Travel request} other {Travel requests}} ({count})',
  },
  purchaseOrderTab: {
    id: `${scope}.purchaseOrderTab`,
    defaultMessage:
      '{count, plural, one {Purchase order} other {Purchase orders}} ({count})',
  },
  billTab: {
    id: `${scope}.billTab`,
    defaultMessage: '{count, plural, one {Bill} other {Bills}} ({count})',
  },
  paymentTab: {
    id: `${scope}.paymentTab`,
    defaultMessage: '{count, plural, one {Payment} other {Payments}} ({count})',
  },
  catalogItemTab: {
    id: `${scope}.catalogItemTab`,
    defaultMessage:
      '{count, plural, one {Catalog item} other {Catalog items}} ({count})',
  },
  vendorTab: {
    id: `${scope}.vendorTab`,
    defaultMessage: '{count, plural, one {Vendor} other {Vendors}} ({count})',
  },
  contractTab: {
    id: `${scope}.contractTab`,
    defaultMessage:
      '{count, plural, one {Contract} other {Contracts}} ({count})',
  },
})
